import { jsx as _jsx } from "react/jsx-runtime";
export const ArrowCircularBottomLeftS = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M4.25098 17.0387C4.25022 16.8399 4.32856 16.6489 4.4685 16.5077L8.46808 12.4722C8.7597 12.1782 9.23463 12.1765 9.52874 12.4681C9.82291 12.7597 9.82449 13.2346 9.53288 13.5287L6.79975 16.2867L14.4833 16.286C17.1162 16.2859 19.2505 14.1514 19.2508 11.5186C19.2508 8.88542 17.1158 6.75044 14.4826 6.75044H7.50133C7.08711 6.75044 6.75072 6.41405 6.75072 5.99983C6.75098 5.58589 7.08666 5.25 7.50064 5.24991H14.4833C17.9447 5.25006 20.7512 8.05648 20.7513 11.5179C20.7513 14.9794 17.9448 17.7857 14.4833 17.7859L6.82322 17.7866L9.52874 20.4686C9.82262 20.7602 9.82497 21.2345 9.53357 21.5286C9.24197 21.8227 8.7664 21.825 8.47222 21.5334L4.47265 17.5683C4.34327 17.4123 4.25191 17.2497 4.25098 17.0387Z",
            fill: color
        })
    });

//# sourceMappingURL=arrow-circular-bottom-left-s.js.map